import React from "react";

import { Field, Form, Formik } from "formik";
import { MdOutlineSend } from "react-icons/md";
import * as Yup from "yup";

import DSButton from "../../../../components/DSButton";
import * as S from "./style";
import { InputWrapper } from "../../../../components/InputWrapper";

export function SendSmsForm({
  phones,
  onSubmit,
  hasPermissionToSendToUnregistered = false,
  onClose,
  isSubmitting = false,
}) {
  const handleChangeSendToUnregisteredSMS = (checked, setFieldValue) => {
    setFieldValue("sendToUnregisteredPhone", checked);
    if (checked) {
      setFieldValue("customPhone", "");
    }
  };

  return (
    <S.FormWrapper>
      <Formik
        initialValues={{
          phone: phones.length === 1 ? phones[0] : "",
          sendToUnregisteredPhone: false,
          customPhone: "",
        }}
        validationSchema={Yup.object({
          phone: Yup.string().nullable(),
          sendToUnregisteredPhone: Yup.boolean(),
          customPhone: Yup.string(),
        }).test({
          name: "has-phone",
          // eslint-disable-next-line consistent-return
          test: (values, ctx) => {
            if (
              (!values.sendToUnregisteredPhone && !values.phone) ||
              (!values.sendToUnregisteredPhone && values.phone === "0")
            ) {
              return ctx.createError({
                path: "phone",
                message: "Insira um número válido",
              });
            }

            if (
              !values.sendToUnregisteredPhone &&
              values.phone &&
              values.phone.length < 14
            ) {
              return ctx.createError({
                path: "phone",
                message: "Número inválido",
              });
            }

            if (values.sendToUnregisteredPhone && !values.customPhone) {
              return ctx.createError({
                path: "customPhone",
                message: "Insira um número válido",
              });
            }

            if (
              values.sendToUnregisteredPhone &&
              values.customPhone &&
              values.customPhone.length < 14
            ) {
              return ctx.createError({
                path: "customPhone",
                message: "Número inválido",
              });
            }
          },
        })}
        onSubmit={onSubmit}
        onReset={onClose}
      >
        {({ setFieldValue, values }) => (
          <Form>
            <Field name="phone">
              {({ field, meta }) => (
                <InputWrapper
                  label="Selecione o número"
                  error={meta.error}
                  isRequired={!values.sendToUnregisteredPhone}
                  name={field.name}
                >
                  <S.CustomSelect
                    value={field?.value || "0"}
                    disabled={values.sendToUnregisteredPhone}
                    className={meta.error ? "error-id" : null}
                    onChange={(value) => {
                      setFieldValue("phone", value);
                    }}
                    id={field.name}
                  >
                    <S.CustomSelect.Option value="0">
                      Selecione
                    </S.CustomSelect.Option>
                    {phones.map((_phone) => (
                      <S.CustomSelect.Option key={_phone} value={_phone}>
                        {_phone}
                      </S.CustomSelect.Option>
                    ))}
                  </S.CustomSelect>
                </InputWrapper>
              )}
            </Field>
            {hasPermissionToSendToUnregistered && (
              <Field name="sendToUnregisteredPhone">
                {({ field }) => (
                  <S.CustomCheckbox
                    checked={field?.value ?? false}
                    onChange={(e) => {
                      handleChangeSendToUnregisteredSMS(
                        e.target.checked,
                        setFieldValue
                      );
                    }}
                  >
                    Enviar para outro número
                  </S.CustomCheckbox>
                )}
              </Field>
            )}
            {hasPermissionToSendToUnregistered &&
              values.sendToUnregisteredPhone && (
                <Field name="customPhone">
                  {({ field, meta }) => (
                    <InputWrapper
                      label="Digite o número"
                      error={meta.error}
                      name={field.name}
                      isRequired={values.sendToUnregisteredPhone}
                    >
                      <S.CustomReactInputMask
                        type="text"
                        className={meta.error ? "error-id" : null}
                        placeholder="Digite o telefone que será enviado"
                        mask="(99) 99999-9999"
                        maskChar=""
                        disabled={!values.sendToUnregisteredPhone}
                        {...field}
                        onChange={(e) => {
                          field?.onChange(e);
                        }}
                        value={field?.value}
                        id={field.name}
                      />
                    </InputWrapper>
                  )}
                </Field>
              )}

            <div className="item-submit">
              <DSButton
                type="reset"
                buttonText="Cancelar"
                buttonType="secondary"
                isCancelType
                height={30}
                style={{
                  padding: "0.4rem 1.5rem",
                }}
                isDisabled={isSubmitting}
                disabled={isSubmitting}
              />
              <DSButton
                type="submit"
                buttonText="Enviar"
                buttonType="secondary"
                icon={<MdOutlineSend />}
                height={30}
                style={{
                  padding: "0.4rem 1.5rem",
                }}
                isLoading={isSubmitting}
                isDisabled={isSubmitting}
                disabled={isSubmitting}
              />
            </div>
          </Form>
        )}
      </Formik>
    </S.FormWrapper>
  );
}
